import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { ApiNotificiacionesService } from '../../../shared/services/api-notificaciones.service';
import { Comunas } from '../../../shared/constants/comunas';
import { ApiDepartamentosService } from 'src/app/shared/services/api-departamentos.service';
import { ApiProcesosService } from 'src/app/shared/services/api-procesos.service';
import { isDefined } from '@angular/compiler/src/util';
import { Router } from '@angular/router';

@Component({
  selector: 'app-modal-proceso',
  templateUrl: './modal-proceso.component.html',
  styleUrls: ['./modal-proceso.component.css']
})
export class ModalProcesoComponent implements OnInit {
  // Loading
  loadingDepartamentos;
  loadingGuardar;
  loadingEditar;
  step = 'init';
  editar;

  // Data
  departamentoSeleccionado;
  id = '';
  departamentos;
  proceso: any;
  procesoAntiguo: any;
  dias;

  constructor(
    public dialogRef: MatDialogRef<ModalProcesoComponent>,
    private apiProcesoService: ApiProcesosService,
    private apiDepartamentosService: ApiDepartamentosService,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    if (data.proceso) {
      this.proceso = data.proceso;
      this.procesoAntiguo = JSON.parse(JSON.stringify(this.proceso));
      this.id = this.proceso.idProceso;
      this.editar = true;
    } else {
      this.editar = false;
      this.proceso = {};
      this.proceso.habilitado = true;
      this.proceso.diaHabilCierreProceso = true;
      this.proceso.diaHabilCoordinador = true;
      this.proceso.diaHabilEmpresa = true;
    }

    this.calcularDias();
  }

  ngOnInit() {
    this.cargarDepartamentos();
  }

  cargarDepartamentos() {
    this.loadingDepartamentos = true;
    this.apiDepartamentosService
      .getDepartamentos()
      .then(res => {
        this.departamentos = res;
        this.loadingDepartamentos = false;
        if (this.editar) {
          this.seleccionarDepartamento();
        }
      })
      .catch();
  }

  seleccionarDepartamento() {
    for (const departamento of this.departamentos) {
      if (
        departamento.idDepartamento ===
        this.proceso.departamento.idDepartamento
      ) {
        this.departamentoSeleccionado = departamento;
        break;
      }
    }
  }

  hayCambios() {
    return (
      this.procesoAntiguo.sigla !== this.proceso.sigla ||
      this.procesoAntiguo.nombre !== this.proceso.nombre ||
      this.procesoAntiguo.diaHabilEmpresa !== this.proceso.diaHabilEmpresa ||
      this.procesoAntiguo.diaMaximoEmpresa !== this.proceso.diaMaximoEmpresa ||
      this.procesoAntiguo.diaHabilCoordinador !==
        this.proceso.diaHabilCoordinador ||
      this.procesoAntiguo.diaMaximoCoordinador !==
        this.proceso.diaMaximoCoordinador ||
      this.procesoAntiguo.diaHabilCierreProceso !==
        this.proceso.diaHabilCierreProceso ||
      this.procesoAntiguo.diaMaximoCierreProceso !==
        this.proceso.diaMaximoCierreProceso ||
      this.procesoAntiguo.habilitado !== this.proceso.habilitado ||
      this.procesoAntiguo.email !== this.proceso.email ||
      this.procesoAntiguo.departamento.idDepartamento !==
        this.departamentoSeleccionado.idDepartamento
    );
  }

  guardarProceso() {
    this.loadingGuardar = true;
    this.apiProcesoService
      .guardarProceso(this.proceso, this.departamentoSeleccionado)
      .then(() => {
        if (this.departamentoSeleccionado.firma) {
          this.step = 'guardarOk';
        } else {
          this.step = 'sinFirma';
        }
        this.loadingGuardar = false;
      })
      .catch(error => {
        if (error.status === 400) {
        }

        this.step = 'error';
        this.loadingGuardar = false;
      });
  }

  editarProceso() {
    this.loadingEditar = true;
    this.apiProcesoService
      .editarProceso(this.proceso, this.departamentoSeleccionado)
      .then(() => {
        if (this.departamentoSeleccionado.firma) {
          this.step = 'editarOk';
        } else {
          this.step = 'sinFirma';
        }
        this.loadingEditar = false;
      })
      .catch(error => {
        if (error.status === 400) {
        }
        this.step = 'error';
        this.loadingEditar = false;
      });
  }

  irMantenedorNotificaciones() {
    this.router.navigate(['/admin/notificaciones']);
    this.cancel();
  }

  camposValidos() {
    return (
      isDefined(this.proceso.nombre) &&
      this.proceso.nombre.trim() !== '' &&
      isDefined(this.proceso.sigla) &&
      this.proceso.sigla.trim() !== '' &&
      isDefined(this.proceso.diaHabilEmpresa) &&
      isDefined(this.proceso.diaMaximoEmpresa) &&
      isDefined(this.proceso.diaHabilCoordinador) &&
      isDefined(this.proceso.diaMaximoCoordinador) &&
      isDefined(this.proceso.diaHabilCierreProceso) &&
      isDefined(this.proceso.diaMaximoCierreProceso) &&
      isDefined(this.proceso.habilitado) &&
      isDefined(this.proceso.email) &&
      this.proceso.email.trim() !== '' &&
      isDefined(this.departamentoSeleccionado)
    );
  }

  cancel(): void {
    this.dialogRef.close();
  }

  ok() {
    this.dialogRef.close(true);
  }

  calcularDias() {
    this.dias = [];
    for (let i = 1; i <= 28; i = i + 1) {
      if (i < 10) {
        this.dias.push({ numero: i, texto: '0' + i });
      } else {
        this.dias.push({ numero: i, texto: '' + i });
      }
    }
  }
}
